//数字补0
function zeroPadding(num) {
  return num < 10 ? '0' + num : num
}

Date.prototype.toLocaleString = function() {
  return this.getFullYear() + '-' + zeroPadding(this.getMonth() + 1) + '-' + zeroPadding(this.getDate())
}
